import { render } from "./ListSettings.vue?vue&type=template&id=7f32cce1"
import script from "./ListSettings.vue?vue&type=script&lang=js"
export * from "./ListSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__